module.exports = __webpack_public_path__ + "static/media/HuangWeiFeng.2c42cec8.png";